import { createContext, useContext, useEffect, useState } from "react";
import { UserDataStorage } from "../Storage/UserDataStorage";

interface AuthContextType {
  isAuthenticated: boolean;
  role: string | null;
  logout: () => void;
  user: any,
  login: (userData: any) => void;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  role: null,
  logout:  () => {},
  user: null,
  login: () => {},
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {

 const storedUser = UserDataStorage.get();
  const [user, setUser] = useState<any | null>(storedUser);
  const [isAuthenticated, setIsAuthenticated] = useState(!!storedUser);
  const [role, setRole] = useState<string | null>(
    storedUser?.roles?.[0] ?? null
  );

  // const [isAuthenticated, setIsAuthenticated] = useState(true);
  // const [role, setRole] = useState<string | null>("Administrator");



 useEffect(() => {
    const handleStorageChange = () => {
      const newUser = UserDataStorage.get();
      if (newUser && newUser.jwToken) {
        setUser(newUser);
        setIsAuthenticated(true);
        const userRole =
          Array.isArray(newUser.roles) && newUser.roles.length > 0
            ? newUser.roles[0]
            : null;
        setRole(userRole);
      } else {
        setUser(null);
        setIsAuthenticated(false);
        setRole(null);
      }
    };

    handleStorageChange(); // Ejecutar una vez al montar
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);


  useEffect(() => {
     console.log("role", role);
     console.log("isAuthenticated", isAuthenticated);
  }, [role, isAuthenticated]);

  const login = (userData: any) => {
    UserDataStorage.save(userData);
    setUser(userData);
    setIsAuthenticated(true);
    setRole(userData.roles?.[0] ?? null);
  };

  const logout = () => {
    UserDataStorage.clear();
    setIsAuthenticated(false);
    setRole(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, logout, user, login }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);